import React, { Component } from 'react'


class NotFound extends Component{
  render() {
    return(
    	<div className="row center">
	    	<h3>
	    		<br/><br/><br/>
	    		Lo siento no se encontro esa pagina
	    	</h3>
    	</div>

    	)
  }
}

export default NotFound;


// WEBPACK FOOTER //
// ./src/routes/404.js